import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";

export default function Comments({ quoteId }) {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get(`/quotes/${quoteId}/comments`).then(r => setItems(r.data));
  useEffect(() => { load(); }, [quoteId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post(`/quotes/${quoteId}/comments`, { text: text.trim(), name: name.trim() || "Anonymous" });
      setText("");
      load();
      toast.success("Comment posted.");
    } catch { toast.error("Comment failed."); }
    finally { setBusy(false); }
  };

  return (
    <div id={`comments-anchor-${quoteId}`} className="border-ink bg-white p-6 shadow-brut-sm mt-8" data-testid="comments-section">
      <div className="flex items-center gap-2 mb-4">
        <MessageCircle size={18} />
        <h3 className="font-display text-xl">Comments · {items.length}</h3>
      </div>
      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-start" data-testid="comment-form">
        <div className="space-y-2">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name (optional)"
            className="border-ink bg-[#F4F4F0] px-3 py-2 w-full font-body text-sm"
            data-testid="comment-name"
          />
          <textarea
            required
            rows={2}
            maxLength={500}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="To be very honest, …"
            className="border-ink bg-[#F4F4F0] px-3 py-2 w-full font-quote text-base"
            data-testid="comment-text"
          />
        </div>
        <button type="submit" disabled={busy} className="btn-ink text-xs" data-testid="comment-submit">
          {busy ? "…" : "Post"}
        </button>
      </form>

      <ul className="mt-6 space-y-4" data-testid="comment-list">
        {items.length === 0 && <li className="font-body text-sm opacity-70">Be the first to say something honest.</li>}
        {items.map(c => (
          <li key={c.id} className="border-t border-[#0A0A0A]/20 pt-3" data-testid={`comment-${c.id}`}>
            <div className="flex items-baseline justify-between">
              <span className="font-ui text-[11px]">{c.name}</span>
              <span className="font-mono text-[10px] opacity-60">{new Date(c.created_at).toLocaleString()}</span>
            </div>
            <p className="font-quote text-lg mt-1">"{c.text}"</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
